import React from "react";
import propTypes from "prop-types";

const Header = ({
    className = "",
    text,
    required = false
}) => {
    return (
        <div className={`smart-header ${className}`}>
            <h5 className="title">{text}</h5>
            {required && <div className="text-lx">
                <i className="far fa-asterisk inline-required" />
                <span>Indicates Required Fields</span>
            </div>}
        </div>
    );
};

Header.propTypes = {
    className: propTypes.string,
    text: propTypes.string.isRequired,
    required: propTypes.bool
};

export default Header;